import { HasImplementationProperties } from './has-implementation-propeties';
import { ImplementationPropertiesUtil } from './implementation-properties-utils';
import { IMSObject, IMSId } from './ims-object';

/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 202208012 by Jan Brunner
 *     all rights reserved.
 */

export type JobSectionLevel = 'LEVEL_1' | 'LEVEL_2' | 'LEVEL_3' | 'LEVEL_4'

export class JobSection extends IMSObject implements HasImplementationProperties {
  static fromDto(dto: JobSectionDTO, databag?: any) {
    const obj = new this(
      {
        imsId: dto.id,
        secondaryId: dto.secondaryid,
        objRef: 'ims/JobSection',
      },
      dto.label,
      new IMSObject(
          dto.servicejob.id,
          undefined,
          dto.servicejob.label,
          'ims/ServiceJob'
        )
    );

    if (databag) {
      obj.databag = databag
    } else {
      obj.databag = dto;
    }

    console.log("JBImplProp test output on jobsection:", obj.implementationProperties.implProps)
    return obj;
  }

  public get servicejob() : IMSObject {
    return this.databag.servicejob && this.databag.servicejob.id != undefined && this.databag.servicejob.id != ""
        ? new IMSObject(
            this.databag.servicejob.id,
            undefined,
            this.databag.servicejob.label,
            'ims/ServiceJob'
          )
        : undefined
  }
  public set servicejob(obj : IMSObject) {
    if (this.databag.servicejob == undefined) {
      this.databag.servicejob = {};
    }
    this.databag.servicejob.id = obj.getImsId();
    this.databag.servicejob.label = obj.label;
    this._sjob = obj
  }

  public get parentjobsection() : IMSObject {
    return this.databag.parentjobsection && this.databag.parentjobsection.id != undefined && this.databag.parentjobsection.id != ""
        ? new IMSObject(
            this.databag.parentjobsection.id,
            undefined,
            this.databag.parentjobsection.label,
            'ims/JobSection'
          )
        : undefined
  }
  public set parentjobsection(obj : IMSObject) {
    if (this.databag.parentjobsection == undefined) {
      this.databag.parentjobsection = {};
    }
    this.databag.parentjobsection.id = obj.getImsId();
    this.databag.parentjobsection.label = obj.label;
  }

  public get name() : string {
    return this.databag.name
  }
  public set name(v : string) {
    this.databag.name = v;
  }

  public get extid() : string {
    return this.databag.extid
  }
  public set extid(v : string) {
    this.databag.extid = v;
  }

  public get level() : JobSectionLevel {
    return this.databag.level
  }
  public set level(v : JobSectionLevel) {
    this.databag.level = v;
  }

  public get implementationProperties(): ImplementationPropertiesUtil {
    return new ImplementationPropertiesUtil(this);
  }
  
  constructor(
    public readonly id: IMSId,
    label: string,
    private _sjob: IMSObject,
  ) {
    super(id.imsId, id.secondaryId, label, 'ims/JobSection');
  }
}

export interface JobSectionDTO {
  id: number;
  secondaryid: number;
  label: string;
  servicejob: {
    id: number;
    label: string;
  };
}
